<div class="card card-statistics mb-30">
  <div class="card-body">
    <h5 class="card-title">فرم ثبت برنامه برای '{{inner_expert_title}}' در تاریخ '{{inner_persianDate}}'</h5>
    <form>

      <div class="row">
        <div class="form-group col-md-8">
          <label for="exampleInputEmail1">شرح</label>
          <input type="text" [(ngModel)]="Dsc" name="Dsc" class="form-control" placeholder="اینجا تایپ کنید ...">
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">نوع برنامه</label>
          <select [(ngModel)]="Type_id" name="Type_id" class="custom-select">
            <option value="0">اقدام عادی</option>
            <option value="2">برنامه ریزی اولیه</option>
            <option value="3">تایید مشتری</option>
            <option value="4">رزرو ماموریت</option>
            <option value="5">تایید نهایی</option>
            <option value="6">تایپ گواهی نامه</option>
            <option value="7">شرایط خاص</option>
          </select>
        </div>
      </div>

      <br/>
      <br/>

      <div class="table-responsive" *ngIf="DataList_Selected_Schedules.length>0">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>شناسه</th>
              <th>شماره نامه</th>
              <th>نام مشتری</th>
              <th>تاریخ</th>
              <th>ساعت</th>
              <th>وضیعت</th>
              <th>آخرین اقدام</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Selected_Schedules">
              <td>{{DataList_Selected_Schedules.indexOf(item)+1}}</td>
              <td>{{item.code2}}</td>
              <td>{{item.code}}</td>
              <td>{{item.customerName}}</td>
              <td>{{item.persianDate}}</td>
              <td>{{item.clock}}</td>
              <td>
                <p *ngIf="item.coordination==-1" style="color:blue ;">در حال تکمیل</p>
                <p *ngIf="item.coordination==1" style="color:green ;">هماهنگ شده</p>
                <p *ngIf="item.coordination==0" style="color:red ;">هماهنگ نشده</p>

                <p *ngIf="item.done==1" style="color:green ;">انجام شده</p>
                <p *ngIf="item.done==0" style="color:red ;">لغو نشده</p>
              </td>
              <td>{{item.activity_date}}</td>
              <td>
                <button ype="button" (click)="delete_hokem(DataList_Selected_Schedules.indexOf(item))" class="btn btn-danger">حذف ماموریت</button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>

      <br/>
      <br/>

      <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
      <button *ngIf="!InProccessing" type="button" (click)="openModal(templateHokem)" class="btn btn-info" style="margin-left: 5px;"><i class="fa  fa-plus"></i> انتخاب حکم </button>
      <button *ngIf="!InProccessing" type="button" (click)="Submit()" class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> ثبت اطلاعات </button>
      <button (click)="On_Back()" *ngIf="!InProccessing" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> بازگشت </button>
    </form>

    <br/>
    <hr/>
    <br/>

    <div class="table-responsive">
      <table class="mb-0 table table-bordered table-3 text-center table-striped">
        <thead style="background-color: #489b39; color: white;">
          <tr>
            <th>#</th>
            <th>شرح</th>
            <th>نوع اقدام</th>
            <th>وضیعت</th>
            <th>تاریخ</th>
            <th>کاربر</th>
            <th>امکانات</th>
          </tr>
        </thead>
        <tbody>
            <ng-container  *ngFor="let item of DataList_Subject">
              <tr >

                <td>{{DataList_Subject.indexOf(item)+1}}</td>
                <td>{{item.dsc}}</td>
                <td>
                  <p *ngIf="item.status" (click)="ChangeStatus(item)" style="color:green ;">منتشر شود</p>
                  <p *ngIf="!item.status" (click)="ChangeStatus(item)" style="color:red ;">منتشر نشود</p>
                </td>
                <td>
                  <p *ngIf="item.type_id==0"  >اقدام عادی</p>
                  <p *ngIf="item.type_id==1"  style="color:rgb(43, 255, 0) ;">مرخصی روزانه</p>
                  <p *ngIf="item.type_id==2"  style="color:red ;">برنامه ریزی اولیه</p>
                  <p *ngIf="item.type_id==3"  style="color:rgb(17, 0, 255) ;">تایید مشتری</p>
                  <p *ngIf="item.type_id==4"  style="color:rgb(235, 117, 6) ;">رزرو ماموریت</p>
                  <p *ngIf="item.type_id==5">تایید نهایی</p>
                  <p *ngIf="item.type_id==6"  style="color:rgb(99, 101, 105) ;">تایپ گواهی نامه</p>
                  <p *ngIf="item.type_id==7">شرایط خاص</p>
                </td>
                <td>{{item.persianDate}}</td>
                <td>{{item.creater}}</td>
                <td>
                  <button type="button" (click)="Delete(item)" class="btn btn-danger" style="margin-left: 5px;">
                    <i class="fa  fa-remove"></i> حذف
                  </button>
                </td>
              </tr>
              <tr *ngIf="item.detail.length>0">
                <td colspan="5">
                  <table class="mb-0 table table-bordered table-3 text-center table-striped">
                    <thead style="background-color: #56399b; color: white;">
                      <tr>
                        <th>#</th>
                        <th>شناسه</th>
                        <th>شماره نامه</th>
                        <th>نام مشتری</th>
                        <th>تاریخ</th>
                        <th>ساعت</th>
                        <th>وضیعت</th>
                        <th>آخرین اقدام</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr  *ngFor="let detail of item.detail">
                        <td>{{item.detail.indexOf(detail)+1}}</td>
                        <td>{{detail.code2}}</td>
                        <td>{{detail.code}}</td>
                        <td>{{detail.customerName}}</td>
                        <td>{{detail.persianDate}}</td>
                        <td>{{detail.clock}}</td>
                        <td>
                          <p *ngIf="detail.coordination==-1" style="color:blue ;">در حال تکمیل</p>
                          <p *ngIf="detail.coordination==1" style="color:green ;">هماهنگ شده</p>
                          <p *ngIf="detail.coordination==0" style="color:red ;">هماهنگ نشده</p>

                          <p *ngIf="detail.done==1" style="color:green ;">انجام شده</p>
                          <p *ngIf="detail.done==0" style="color:red ;">لغو نشده</p>
                        </td>
                        <td>{{detail.activity_date}}</td>
                      </tr>


                    </tbody>
                  </table>
                </td>
              </tr>
            </ng-container>
        </tbody>
      </table>
    </div>

  </div>
</div>




<ng-template #templateHokem>
  <div class="modal-header">
    <h4 class="modal-title pull-left">لیست اطلاعات حکم های سامانه </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Hokem.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1">شماره نامه</label>
          <input [(ngModel)]="Filter_Letter" name="Filter_Letter" type="number" class="form-control"
            placeholder="برای جستجوی ، اینجا تایپ کنید ...">
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>شناسه</th>
              <th>شماره نامه</th>
              <th>نام مشتری</th>
              <th>تاریخ</th>
              <th>ساعت</th>
              <th>وضیعت</th>
              <th>آخرین اقدام</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Schedules">
              <td>{{DataList_Schedules.indexOf(item)+1}}</td>
              <td>{{item.code2}}</td>
              <td>{{item.code}}</td>
              <td>{{item.customerName}}</td>
              <td>{{item.persianDate}}</td>
              <td>{{item.clock}}</td>
              <td>
                <p *ngIf="item.coordination==-1" style="color:blue ;">در حال تکمیل</p>
                <p *ngIf="item.coordination==1" style="color:green ;">هماهنگ شده</p>
                <p *ngIf="item.coordination==0" style="color:red ;">هماهنگ نشده</p>

                <p *ngIf="item.done==1" style="color:green ;">انجام شده</p>
                <p *ngIf="item.done==0" style="color:red ;">لغو نشده</p>
              </td>
              <td>{{item.activity_date}}</td>
              <td>
                <button ype="button" (click)="select_hokem(item)" class="btn btn-info">انتخاب ماموریت</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  </div>
  <div class="modal-footer">
    <img *ngIf="Procssing_schedule" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!Procssing_schedule" type="button" (click)="ReadData_Schedules()" class="btn btn-info"
      style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Hokem.hide()">بستن</button>
  </div>
</ng-template>
